module.exports = __webpack_public_path__ + "img/fire-logo.a31fe253.png";